const _getters = {
}

export default _getters
